






















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Events extends Vue {
    @Prop() public events!: Array<any>;
}
